import React from "react";

import MenuItem from "./MenuItem";

export default function Category(props) {
  const { menu, categories, lang } = props;

  return (
    <div className="category-component">
      {categories.map((cat, index) => {
        return <CategoryItem key={index} cat={cat} menu={menu} lang={lang} />;
      })}
    </div>
  );
}

const CategoryItem = (props) => {
  const { cat, menu, lang } = props;

  const catMenu = menu.filter((item) => {
    return item["category_" + lang] === cat;
  });
  return (
    <>
      <h2 id={cat}>{cat}</h2>
      <ul>
        {catMenu.map((item, index) => {
          return <MenuItem key={index} menuItem={item} lang={lang} />;
        })}
      </ul>
    </>
  );
};
